<template>
  <div class="p-6">
    <h3 class="text-[18px] font-bold text-grey-light-900">Cancellation Reason</h3>
    <p class="text-[14px] text-grey-light-600 mt-1">Send cancellation request for this order</p>

    <hr class="my-4" />

    <RefundSummary
      :refund-before-deductions="refundBeforeDeductions"
      :cancellation-fee="cancellationFee"
      :refund-after-deductions="refundAfterDeductions"
    />

    <hr class="my-4" />

    <p class="text-[14px] text-grey-light-600">
      Cancellation of this payment plan and related fees will be subject to the
      <span class="font-bold">{{ merchantName }}</span> approval.
    </p>

    <div class="mt-4 space-y-4">
      <div>
        <p class="text-[14px] font-semibold text-grey-light-700 mb-2">Reason for cancelling</p>
        <Select :model-value="selectedReason" @update:model-value="$emit('update:selectedReason', $event)">
          <SelectTrigger :class="isDesktop ? 'max-w-[400px]' : 'max-w-[350px]'">
            <SelectValue placeholder="Please select your reason" />
          </SelectTrigger>
          <SelectContent :class="isDesktop ? 'max-w-[400px]' : 'max-w-[350px]'">
            <SelectItem v-for="reason in cancellationReasons" :key="reason" :value="reason">
              {{ reason }}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <p class="text-[14px] font-semibold text-grey-light-700 mb-2">Update to message</p>
        <textarea
          :value="cancellationMessage"
          placeholder="Message..."
          class="w-full min-h-[100px] rounded-lg border border-grey-light-200 p-3 text-[14px] resize-none focus:outline-none focus:ring-2 focus:ring-brand-300 focus:border-brand-300"
          @input="$emit('update:cancellationMessage', ($event.target as HTMLTextAreaElement).value)"
        />
      </div>
    </div>

    <hr class="my-4" />

    <div class="flex gap-3">
      <Button variant="outline" class="flex-1" @click="$emit('close')">Cancel</Button>
      <Button class="flex-1 bg-teal-600 hover:bg-teal-700" :disabled="!selectedReason" @click="$emit('next')">
        Next
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import RefundSummary from '@/components/shopper/lay-by/cancellation-request/RefundSummary.vue';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useBreakpoint } from '@/utils/useBreakPoint';

const { isDesktop } = useBreakpoint();

defineProps<{
  refundBeforeDeductions: number;
  cancellationFee: number;
  refundAfterDeductions: number;
  selectedReason: string;
  cancellationMessage: string;
  merchantName: string;
  cancellationReasons: string[];
}>();

defineEmits<{
  'update:selectedReason': [value: string];
  'update:cancellationMessage': [value: string];
  next: [];
  close: [];
}>();
</script>
